<template>
<v-container>
  <v-row>
    <v-col cols="3" sm="10">
      <v-alert prominent type="success" text shaped dark>
        <v-row align="center">
          <v-col class="grow">
            <div v-if="formState !== 'edit'">
              {{ formTitle }} جدید با موفقیت ثبت شد
            </div>
            <div v-if="formState === 'edit'">
              اطلاعات {{ formTitle }} با موفقیت ویرایش شد
            </div>
          </v-col>
        </v-row>
      </v-alert>
    </v-col>

    <v-col cols="3" sm="2">
      <div class="text-center">
        <div class="text-center">
          <v-btn v-if="showTelegramBtn" fab small class="mx-2 white--text" color="primary" v-shortkey="['enter']" @shortkey="telegram()" @click="telegram">
            <v-icon dark>mdi-send</v-icon>
          </v-btn>
          <v-btn v-if="!showTelegramBtn && !this.invoice.items[0].lending_value" fab small class="mx-2 white--text" color="grey darken-4" v-shortkey="{fa: ['ctrl'+'ح'], en: ['ctrl'+'p']}" @shortkey="printAllLabels()" @click="printAllLabels">
            <v-icon dark>mdi-printer-pos</v-icon>
          </v-btn>

          <v-btn fab small class="mx-2 white--text" color="grey" v-shortkey="['esc']" @shortkey="back()" to="/">
            <v-icon dark>mdi-logout-variant</v-icon>
          </v-btn>
        </div>
      </div>
    </v-col>
  </v-row>

  <print-invoice-label v-if="invoice && invoice.type !== 'buy'" :alert="alert" :show-weight-table="showWeightTable" :invoice="invoice" @getWS="getWeightSplits($event)" @child-print-row="printInvoiceLabelwithoutShow($event)" />
</v-container>
</template>

<script>
import vueAxios from '../../functions/vueAxios'
import MySendToTelegram from '../../functions/sendToTelegram'
import PrintInvoiceLabel from './printInvoiceLabel.vue'

export default {
  name: 'MyAlert',
  components: {
    PrintInvoiceLabel
  },
  props: ['idForTg', 'invoice', 'alert', 'showWeightTable'],
  data() {
    return {
      showTelegramBtn: true,
      subWeightSplits: []
    }
  },
  async beforeCreate() {
    this.route = this.$store.getters.pageInfo.route
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.formTitle = this.$store.getters.pageInfo.formTitle
  },
  methods: {

    async telegram() {
      try {
        await MySendToTelegram(this.idForTg);
        this.back();
      } catch (e) {
        console.error('ارسال به تلگرام ناموفق بود:', e)
      }
    },

    async printInvoiceLabel(item) {
      try {
        const product = (this.invoice.products || []).filter(product => product._id === item.product_id)
        const value = !item.second_value ? Math.abs(Number(item.value).toFixed(3)) : Math.abs(Number((item.value / (product[0]?.n || 1)).toFixed(3)))
        const res = await vueAxios.get('/invoices/label', {
          params: {
            amount: value,
            unit: !item.second_value ? 'G' : 'M',
            invoice_id: this.invoice.id,
            invoice_date: item.invoice_date
          },
          responseType: 'blob',
        })

        const file = new Blob([res.data], {
          type: 'application/pdf'
        })
        const fileURL = URL.createObjectURL(file)
        window.open(fileURL, '_blank')

        setTimeout(() => {
          URL.revokeObjectURL(fileURL)
        }, 2000)
      } catch (err) {
        console.error("❌ Error fetching label PDF:", err)
      }
    },

    async printInvoiceLabelwithoutShow(item) {
      try {
        const res = await vueAxios.get('/invoices/label', {
          params: {
            amount: item.weight,
            unit: item.n === 1 ? 'G' : 'M',
            invoice_id: this.invoice.id,
            invoice_date: this.invoice.create_date
          },
          responseType: 'blob',
        })

        const file = new Blob([res.data], {
          type: 'application/pdf'
        })
        const fileURL = URL.createObjectURL(file)
        //
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = fileURL
        document.body.appendChild(iframe)

        iframe.onload = () => {
          const printWindow = iframe.contentWindow
          printWindow.focus()
          printWindow.print()
        }
      } catch (err) {
        console.error("❌ Error fetching QR PDF:", err)
      }
    },

    async printAllLabels() {
      // const itemsWithoutDiscount = (this.invoice.items || []).filter(item => item.value)
      for (const item of this.subWeightSplits) {
        await this.printInvoiceLabelwithoutShow(item)
        await new Promise(resolve => setTimeout(resolve, 500))
        //focus
        this.$nextTick(() => {
          const firstInput = this.$el.querySelector('tbody tr:first-child input')
          if (firstInput) firstInput.focus()
        })
      }
    },

    getWeightSplits(arg) {
      this.subWeightSplits = arg
    },

    back() {
      if (this.showTelegramBtn) {
        (this.route === 'invoices' && !this.invoice?.items[0]?.lending_value && this.invoice?.type !== "buy") ? (this.showTelegramBtn = false, this.$emit('telegramSent')) : this.$router.go(-1)
      } else {
        this.$router.go(-1)
      }
    },
  }
}
</script>
